import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuthStore } from '@/store';
import { useI18n } from '@/components/I18nProvider';
import { cn } from '@/lib/utils';
import {
  LayoutDashboard,
  Users,
  CreditCard,
  MessageCircle,
  Settings,
  Building2,
  ScrollText,
  FileText,
} from 'lucide-react';

const companyNav = [
  { to: '/dashboard', icon: LayoutDashboard, labelKey: 'dashboard' },
  { to: '/customers', icon: Users, labelKey: 'customers' },
  { to: '/payments', icon: CreditCard, labelKey: 'payments' },
  { to: '/whatsapp', icon: MessageCircle, labelKey: 'whatsapp' },
  { to: '/settings', icon: Settings, labelKey: 'settings' },
];

const adminNav = [
  { to: '/admin', icon: LayoutDashboard, labelKey: 'dashboard', end: true },
  { to: '/admin/companies', icon: Building2, labelKey: 'companies' },
  { to: '/admin/templates', icon: FileText, labelKey: 'messageTemplates' },
  { to: '/admin/messages', icon: ScrollText, labelKey: 'messageLogs' },
  { to: '/admin/settings', icon: Settings, labelKey: 'settings' },
];

export const BottomNav = () => {
  const { user } = useAuthStore();
  const { t } = useI18n();
  const items = user?.role === 'super_admin' ? adminNav : companyNav;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/10 bg-[hsl(var(--sidebar-bg))] lg:hidden"
      data-testid="bottom-nav"
    >
      <div className="flex h-16 items-center justify-around px-1">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-testid={`bnav-${item.to.replace(/\//g, '-').replace(/^-/, '')}`}
            className={({ isActive }) =>
              cn(
                'flex flex-1 flex-col items-center gap-0.5 py-1 text-[10px] font-medium transition-colors',
                isActive
                  ? 'text-emerald-400'
                  : 'text-white/50'
              )
            }
          >
            {({ isActive }) => (
              <>
                <div className={cn(
                  'flex h-8 w-8 items-center justify-center rounded-xl transition-all duration-200',
                  isActive && 'bg-emerald-500/20 scale-110'
                )}>
                  <item.icon className={cn('h-5 w-5', isActive && 'stroke-[2.5]')} />
                </div>
                <span className="leading-none notranslate" translate="no">{t(item.labelKey)}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
      {/* Safe area for devices with home indicator */}
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
};
